<template>
  <span style="margin-top: -4px">
    <span class="tw-hidden xl:tw-inline-block badge badge-info tw-py-1 text-uppercase" v-if="fuelType == 'hybrid'">HYBRID</span>
  <span class="tw-hidden xl:tw-inline-block badge badge-success tw-py-1 text-uppercase" v-if="fuelType == 'plug-in hybrid'">PLUG IN</span>
  <span class="tw-hidden xl:tw-inline-block badge badge-success tw-py-1 text-uppercase" v-if="fuelType == 'elektromos'">ELEKTROMOS</span>
  <span class="tw-hidden xl:tw-inline-block badge badge-success tw-py-1 text-uppercase" v-if="fuelType == 'hidrogén'">ELEKTROMOS</span>
  </span>
</template>

<script>
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class FuelTypeBadge extends Vue {

  @Prop(String) fuelType;

}
</script>
